import { signal } from "@angular/core";

export class TabSignalSet<T> {
    readonly aspect = signal<T | undefined>(undefined);
    readonly batch = signal<T | undefined>(undefined);
    readonly client = signal<T | undefined>(undefined);
    readonly content = signal<T | undefined>(undefined);
    readonly import = signal<T | undefined>(undefined);
    readonly role = signal<T | undefined>(undefined);
    readonly type = signal<T | undefined>(undefined);
    readonly user = signal<T | undefined>(undefined);
}
